const numberFormat = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

export const formatNumber = (value: number | null | undefined): string =>
  value != null && Number.isFinite(value) ? numberFormat.format(value) : '—';
